import ViewListOutlinedIcon from '@material-ui/icons/ViewListOutlined';

import TiposTransaccionList from './TiposTransaccionList';
import TiposTransaccionShow from './TiposTransaccionShow';

const tiposTransaccion = {
    icon: ViewListOutlinedIcon,
    list: TiposTransaccionList,
    show: TiposTransaccionShow,
};

export default tiposTransaccion;
